import styled from 'styled-components';
import Theme from '@dagensmat/carrot/Theme';
import { Typography } from '@dagensmat/carrot/Components';

export const DayTotalContainer = styled.div`
  margin-top: ${Theme.Spacings.m}px;
`;

export const DayTotal = styled(Typography)`
  order: 1;
  text-align: right;
  flex: auto;
`;
